import { createGate } from 'effector-react';
import { createEvent } from 'effector';

export const UsersLogGate = createGate();

export const UsersListGate = createGate();

export const setAdminBlockUserModalEv = createEvent();
export const blockUserEv = createEvent();
export const unblockUserEv = createEvent();

export const UserLoginHistoryGate = createGate();

export const changeUserLoginTableEv = createEvent();
export const changeUsersLogTableEv = createEvent();
export const changeUsersListTableEv = createEvent();

export const changeUserPasswordByAdminEv = createEvent();
export const setAdminChangePassModalEv = createEvent();

export const setAdminCreateUserModalEv = createEvent();
export const submitAdminCreateUserEv = createEvent();
